import { Component, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NZ_MODAL_DATA } from 'ng-zorro-antd/modal';
import { NzTableModule } from 'ng-zorro-antd/table';
import { NzTagModule } from 'ng-zorro-antd/tag';
import { NzEmptyModule } from 'ng-zorro-antd/empty';

@Component({
  selector: 'beautyapp-package-detail-modal',
  standalone: true,
  imports: [CommonModule, NzTableModule, NzTagModule, NzEmptyModule],
  template: `
    <nz-table
      [nzData]="data.services"
      [nzFrontPagination]="false"
      [nzShowPagination]="false"
      nzSize="small"
      nzBordered
    >
      <thead>
        <tr>
          <th>სერვისი</th>
          <th nzWidth="55px" nzAlign="center">სულ</th>
          <th nzWidth="65px" nzAlign="center">გამოყ.</th>
          <th nzWidth="60px" nzAlign="center">დარჩ.</th>
          <th nzWidth="75px" nzAlign="right">ფასი</th>
        </tr>
      </thead>
      <tbody>
        @for (s of data.services; track s.serviceId) {
        <tr>
          <td>{{ s.serviceName }}</td>
          <td nzAlign="center">{{ s.totalQuantity }}</td>
          <td nzAlign="center">{{ s.usedQuantity }}</td>
          <td nzAlign="center">
            <nz-tag [nzColor]="s.remainingQuantity <= 1 ? 'red' : 'green'">{{
              s.remainingQuantity
            }}</nz-tag>
          </td>
          <td nzAlign="right">{{ effectivePrice(s) | number : '1.2-2' }} ₾</td>
        </tr>
        }
      </tbody>
    </nz-table>

    @if (data.usages.length) {
    <div class="usage-section">
      <div class="usage-header">გამოყენების ისტორია</div>
      <div class="usage-list">
        @for (u of data.usages; track $index) {
        <div class="usage-row">
          <span class="usage-name">
            {{ u.service?.name || '—' }}
            <span class="usage-qty">(x{{ u.quantityUsed }})</span>
          </span>
          <span class="usage-date">{{
            u.usedAt | date : 'dd/MM/yyyy HH:mm'
          }}</span>
        </div>
        }
      </div>
    </div>
    }
  `,
  styles: [
    `
      :host {
        display: block;
      }

      .usage-section {
        margin-top: 16px;
      }

      .usage-header {
        font-weight: 600;
        font-size: 13px;
        color: #333;
        padding-bottom: 8px;
        border-bottom: 1px solid #e8e8e8;
        margin-bottom: 4px;
      }

      .usage-list {
        max-height: 240px;
        overflow-y: auto;
      }

      .usage-row {
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 7px 4px;
        border-bottom: 1px solid #f5f5f5;
        font-size: 13px;
      }

      .usage-row:last-child {
        border-bottom: none;
      }

      .usage-name {
        color: #333;
      }

      .usage-qty {
        color: #999;
        font-size: 12px;
      }

      .usage-date {
        color: #999;
        font-size: 12px;
        white-space: nowrap;
        margin-left: 12px;
      }
    `,
  ],
})
export class PackageDetailModalComponent {
  data = inject(NZ_MODAL_DATA);

  /**
   * Unit price actually charged: BE effectivePrice when present, otherwise the
   * no-discount fallback (discountedPrice > 0 ? discounted : original).
   * discountedPrice = 0 means "no discount", NOT free.
   */
  effectivePrice(s: {
    effectivePrice?: number;
    discountedPrice: number;
    originalPrice: number;
  }): number {
    if (typeof s.effectivePrice === 'number') return s.effectivePrice;
    const discounted = Number(s.discountedPrice);
    return discounted > 0 ? discounted : Number(s.originalPrice);
  }
}
